import React, { useEffect } from "react";
import GuideSection from "../../components/guide/GuideSection";
import { formalitiesGuide } from "../../components/guide/guideContent";
import {
  FiArrowRight,
  FiAward,
  FiDollarSign,
  FiEdit3,
  FiFeather,
  FiFileText,
  FiCheckCircle,
  FiFlag,
  FiGlobe,
  FiHash,
  FiHome,
  FiMap,
  FiPackage,
  FiPercent,
  FiShield,
  FiTrendingUp,
  FiUser,
  FiUsers,
  FiWifi,
  FiZap,
} from "react-icons/fi";
import AppNavbar from "../../components/home/Navbar";
import Seo from "../../components/seo/Seo";
import { useNavigate } from "react-router-dom";
import { addToCart, removeFromCart } from "../../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import { formatPrice } from "../../utils/formatPrice";
import "../styles/options.css";
import { PAGES } from "../../content/pages";

function Formalities() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useSelector((state) => state.authUser);
  const { userCompanies } = useSelector((state) => state.companies);

  const formalities = [
    // Business formalities first, personal documents last
    {
      name: "Attestation d'immatriculation (NIU)",
      description: "Obtenez votre attestation d'immatriculation",
      from: "taxRegistration",
      icon: FiHash,
      active: true,
      price: 5000,
    },
    {
      name: "Attestation de conformité fiscale",
      description: "Obtenez votre attestation de conformité fiscale",
      from: "taxCompliance",
      icon: FiCheckCircle,
      active: true,
      price: 5000,
    },
    {
      name: "Immatriculation de l'entreprise à la CNPS",
      description: "Immatriculez votre entreprise à la CNPS",
      from: "cnpsRegistration",
      icon: FiUsers,
      active: true,
      price: 30000,
    },
    {
      name: "Identité visuelle",
      description: "Logo, cartes de visite, plaquettes et cachets",
      from: "visualIdentity",
      icon: FiFeather,
      active: true,
      priceFrom: 13000,
      price: 0,
      delay: "1 semaine environ",
    },
    {
      name: "Inscription au fichier des importateurs",
      description: "Obtenez votre attestation d'inscription.",
      from: "importation",
      icon: FiPackage,
      active: true,
      delay: "1 semaine en moyenne",
      price: 120000,
    },
    {
      name: "Protection du nom commercial à l'OAPI",
      description: "Protégez le nom de votre entreprise",
      from: "oapi",
      icon: FiAward,
      active: true,
      delay: "2 semaines de recherche, puis 3 à 6 mois pour les documents",
      price: 215000,
    },
    {
      name: "Protection de la marque à l'OAPI",
      description: "Protégez votre marque et son logo",
      from: "trademark",
      icon: FiShield,
      active: true,
      price: 750000,
    },
    {
      name: "Branchement ENEO",
      description: "Souscrivez à un branchement ENEO",
      from: "eneo",
      icon: FiZap,
      active: true,
      price: 100000,
    },
    {
      name: "Monter un Business plan light",
      description: "Obtenez un business plan optimisé",
      from: "businessPlan",
      icon: FiTrendingUp,
      active: true,
      price: 75000,
    },
    {
      name: "Extrait de casier judiciaire",
      description: "Obtenez votre extrait de casier judiciaire",
      from: "crimRecord",
      icon: FiFileText,
      price: 7000,
      active: true,
    },
    {
      name: "Certificat de nationalité",
      description: "Obtenez un certificat de nationalité",
      from: "certificateNationality",
      icon: FiFlag,
      price: 7000,
      active: true,
    },
    {
      name: "Certificat de célibat",
      description: "Obtenez un certificat de célibat",
      from: "certificateSingleness",
      icon: FiUser,
      price: 7000,
      active: true,
    },
    {
      name: "Pré-enrôlement Passeport",
      description: "Effectuez votre pré-enrôlement",
      from: "passport",
      icon: FiGlobe,
      active: true,
      price: 120000,
    },
    {
      name: "Abattement douanier",
      description: "Obtenez un abattement douanier",
      from: "customsRebate",
      icon: FiPercent,
      active: false,
      price: 10000,
    },
    {
      name: "Modification des statuts d’entreprise",
      description: "Modifiez les statuts de votre entreprise",
      from: "company-modification",
      icon: FiEdit3,
      active: false,
    },
    {
      name: "Demande de recouvrement",
      description: "Obtenez un recouvrement des créances",
      from: "debt-recovery",
      icon: FiDollarSign,
      active: false,
    },

    {
      name: "Permis de bâtir",
      description: "Obtenez un permis de bâtir",
      from: "building-permit",
      icon: FiHome,
      active: false,
    },
    {
      name: "E-Visa Cameroun",
      description: "Obtenez un e-visa pour le Cameroun",
      from: "visa-cameroun",
      icon: FiMap,
      active: false,
    },
    {
      name: "Visa Schengen",
      description: "Obtenez un visa Schengen",
      from: "visa-schengen",
      icon: FiMap,
      active: false,
    },
    {
      name: "Visa Canada",
      description: "Obtenez un visa pour le Canada",
      from: "visa-canada",
      icon: FiMap,
      active: false,
    },
    // {
    //   name: "Assurance de voyage",
    //   description: "Obtenez une assurance de voyage",
    //   from: "travel-insurance",
    //   active: false,
    // },

    // {
    //   name: "Assurance R.C.C.E.",
    //   description: "Souscrivez à une assurance R.C.C.E.",
    //   from: "rccce-insurance",
    //   active: false,
    // },
    {
      name: "Abonnement internet CAMTEL",
      description: "Souscrivez à un abonnement internet",
      from: "camtel-internet",
      icon: FiWifi,
      active: false,
    },

    // {
    //   name: "Abonnement CAMWATER",
    //   description: "Souscrivez à un abonnement CAMWATER",
    //   from: "camwater",
    //   active: false,
    // },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const startFormality = async (formality) => {
    // A previous visual identity order must not show up in this one
    await dispatch(removeFromCart("visualIdentity"));
    await dispatch(
      addToCart({
        from: formality.from,
        price: formality.price,
      }),
    );
    if (user && isAuthenticated) {
      switch (formality.from) {
        case "crimRecord":
          navigate("/birth-place");
          break;

        case "certificateNationality":
          navigate("/certificate-nationality-country");
          break;

        case "certificateSingleness":
          navigate("/certificate-singleness-country");
          break;

        case "eneo":
          navigate("/eneo-country");
          break;

        case "customsRebate":
          navigate("/customs-rebate-country");
          break;

        case "businessPlan":
          navigate("/business-plan-sector-activity");
          break;

        case "visualIdentity":
          navigate("/visual-identity");
          break;

        case "passport":
          navigate("/passport-country");
          break;

        case "importation":
          if (Array.isArray(userCompanies) && userCompanies.length > 0) {
            navigate("/importation-companies");
          } else {
            navigate("/importation-business-country");
          }
          break;

        case "oapi":
          if (Array.isArray(userCompanies) && userCompanies.length > 0) {
            navigate("/oapi-companies");
          } else {
            navigate("/oapi-business-country");
          }
          break;

        case "trademark":
          navigate("/trademark");
          break;

        case "taxRegistration":
          navigate("/tax-registration");
          break;

        case "taxCompliance":
          navigate("/tax-compliance");
          break;

        case "cnpsRegistration":
          navigate("/cnps-registration");
          break;

        default:
          // Rien à faire ici
          break;
      }
    } else {
      navigate("/formality-account-check");
    }
  };

  const available = formalities.filter((formality) => formality.active);
  const upcoming = formalities.filter((formality) => !formality.active);

  const priceLabel = (formality) =>
    formality.priceFrom
      ? `À partir de ${formatPrice(formality.priceFrom)}`
      : Number(formality.price) > 0
        ? formatPrice(formality.price)
        : "Gratuit";

  return (
    <div className="options-page formalities-page">
      <Seo {...PAGES.formalities} />
      <AppNavbar />

      <div className="container options-container formalities-container">
        <header className="options-header">
          <h1 className="options-title">
            <span>Formalités</span> diverses
          </h1>
          <p className="options-lead">
            Chaque procédure est simplifiée pour vous aider à accomplir vos
            démarches rapidement, depuis chez vous.
          </p>
        </header>

        <div className="formality-grid">
          {available.map((formality) => {
            const Icon = formality.icon;

            return (
              <article
                key={formality.from}
                className="option-card formality-card"
              >
                <span className="option-icon" aria-hidden="true">
                  <Icon />
                </span>
                <h2 className="option-title">{formality.name}</h2>
                <p className="option-summary">{formality.description}</p>

                <div className="formality-facts">
                  <strong>{priceLabel(formality)}</strong>
                </div>

                <button
                  type="button"
                  className="formality-cta"
                  onClick={() => startFormality(formality)}
                >
                  Commander <FiArrowRight aria-hidden="true" />
                </button>
              </article>
            );
          })}
        </div>

        {upcoming.length > 0 && (
          <>
            <h2 className="options-section-title">Bientôt disponibles</h2>
            <ul className="formality-upcoming">
              {upcoming.map((formality) => {
                const Icon = formality.icon;

                return (
                  <li key={formality.from}>
                    <Icon aria-hidden="true" />
                    {formality.name}
                  </li>
                );
              })}
            </ul>
          </>
        )}
      </div>

      <GuideSection {...formalitiesGuide} />
    </div>
  );
}

export default Formalities;
